import { FrontendPageContent } from "@/components/frontend/FrontendPageContent";
import { HOME_ORG_PATH } from "@/config/constants";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { ClauseLibraryTable } from "./components/ClauseLibraryTable";

const OrganizationClauseLibrary = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Clause Library");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Home", path: HOME_ORG_PATH },
            { label: "Clause Library" },
        ]);
    });

    return (
        <FrontendPageContent className="overflow-y-auto p-4">
            <ClauseLibraryTable />
        </FrontendPageContent>
    );
};

export default OrganizationClauseLibrary;
